import { ReactNode } from "react";
import Grid from "@mui/material/Grid";
import SoftBox from "../../../../components/common/softBox";
import SoftTypography from "../../../../components/common/softTypography";
import PageLayout from "../../../../components/layoutContainers/pageLayout";

interface CoverLayoutProps {
  color?:
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "dark"
    | "light";
  header?: ReactNode;
  title?: string;
  description?: string;
  image?: string;
  top?: number;
  children: ReactNode;
}

const CoverLayout: React.FC<CoverLayoutProps> = ({
  color = "info",
  header = "",
  title = "",
  description = "",
  image,
  top = 20,
  children,
}) => {
  return (
    <PageLayout>
      <Grid
        container
        justifyContent="center"
        display="flex"
        alignItems="center"
        sx={{ minHeight: "100vh", margin: 0 }}
      >
        <Grid
          item
          xs={11}
          sm={8}
          md={5}
          xl={3}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "15px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
        >
          <SoftBox px={3} py={3}>
            <SoftBox pb={3} borderBottom="1px solid #eee" borderRadius="none">
              {!header ? (
                <>
                  <SoftBox mb={1} textAlign="center">
                    <SoftTypography
                      textAlign="center"
                      variant="h3"
                      fontWeight="bold"
                      color={color}
                    >
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography
                    variant="body2"
                    textAlign="center"
                    fontWeight="regular"
                    color="text"
                    fontSize="14px"
                  >
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            <SoftBox pt={2}>{children}</SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
};

export default CoverLayout;
